const es = {
    "Pinça robótica": "Pinza robótica",
    "Porta-agulhas robótico": "Portaagujas robótico",
    "Tesoura robótica": "Tijera robótica",
    "Não": "No",
    "Ressecção de Tumor intracardíaco": "Resección de tumor intracardíaco",
    "Transplante Cardíaco": "Trasplante cardíaco",
    "Implante de eletrodo epicárdico": "Implante de electrodo epicárdico",
    "Janela pleuropericárdica": "Ventana pleuropericárdica",
    "Pericardiectomia": "Pericardiectomía",
    "Cox Maze": "Cox Maze",
    "Fechamento de auriculeta": "Cierre de la orejuela","Campos_Obrigatorios": "The following fields are required:",
    "Identificacao": "Identificación",
    "Identificacao_Descricao": "Formulario que recoge los datos básicos de identificación del paciente",
    "PreOperatorio": "Preoperatorio",
    "PreOperatorio_Descricao": "Evaluación prequirúrgica centrada en exámenes y preparación del paciente",
    "Escores": "Puntuaciones",
    "Escores_Descricao": "Colección de puntuaciones clínicas para evaluar el estado de salud del paciente",
    "Anestesia": "Anestesia",
    "Anestesia_Descricao": "Información sobre el proceso anestésico y la sedación del paciente",
    "Incisao": "Incisión",
    "Incisao_Descricao": "Registro del inicio de la cirugía, incluidos los detalles de la incisión",
    "Circulacao_Extracorporea": "Circulación Extracorpórea",
    "Circulacao_Extracorporea_Descricao": "Información sobre el uso de la circulación extracorpórea durante la cirugía",
    "Cirurgia": "Cirugía",
    "Pacientes": "Pacientes",
    "logout": "Salir",
    "Cirurgia_Descricao": "Detalles del procedimiento quirúrgico principal realizado al paciente",
    "PosOperatorio": "Posoperatorio",
    "PosOperatorio_Descricao": "Monitorización y cuidado postoperatorio inmediato",
    "Hemotransfusao": "Transfusión de Sangre",
    "Hemotransfusao_Descricao": "Registro de las transfusiones de sangre realizadas durante o después de la cirugía",
    "Obito": "Fallecimiento",
    "Obito_Descricao": "Registro de información relacionada con el fallecimiento del paciente",
    "(cm)": "(cm)",
    "(kg)": "(kg)",
    "(kg/m2)": "(kg/m2)",
    "(m2)": "(m2)",
    "(em uso de broncodilatador inalatório)": "(usando un broncodilatador inhalado)",
    "(prévia à cirurgia)": "(Previa a la cirugía)",
    "(prescrição nutricional, de exercícios ou estratégias de psicoterapia para melhorar a capacidade funcional no pré-operatório)": "(nutrición, ejercicio o estrategias psicológicas que buscan mejorar la capacidad funcional antes de la cirugía)",
    "(%)": "(%)",
    "(mg/dl)": "(mg/dl)",
    "(pior dispneia ou classe funcional nas últimas 2 semanas)": "(peor disnea o clase funcional del paciente en las últimas 2 semanas)",
    "(Classificação de angina da Canadian Cardiovascular Society)": "(Clasificación de angina de la Sociedad Cardiovascular Canadiense)",
    "(%, mortalidade)": "(%)",
    "(1 ponto para cada resposta positiva: Fadigado? Não consegue subir 1 lance de escadas? Não consegue caminhar um quarteirão? Possui mais de 5 doenças? Perdeu mais de 5% do peso nos últimos 6 meses?)": "(1 punto por cada respuesta positiva: Fatigado? No puede subir un tramo de escaleras? No puede caminar una cuadra? Tiene más de 5 enfermedades? Pérdida de más del 5% del peso en los últimos 6 meses?)",
    "(e.g. Morfina 10 mg e Fentanil 300 mcg)": "(ej. Morfina 10 mg, Fentanilo 300 mcg)",
    "(beating heart surgery)": "(Cirugía con corazón latiendo)",
    "(Marca/especificação)": "(Marca/especificación)",
    "(Fr)": "(Fr)",
    "(min)": "(min)",
    "(min, 'de pele a pele')": "(min)",
    "(qualquer lesão de pelo menos 50%)": "(cualquier lesión de al menos 50% de obstrucción)",
    "(mm)": "(mm)",
    "(horas)": "(horas)",
    "(dias, após a cirurgia)": "(días después de la cirugía)",
    "ID do paciente": "Número de registro",
    "Hospital": "Hospital",
    "ID no hospital": "Número de Hospital",
    "Nome": "Nombre",
    "CPF": "Documento Nacional de Identidade",
    "Idade": "Edad",
    "Sexo": "Sexo",
    "Altura": "Altura (cm)",
    "Altura (cm)":  "Altura (cm)",
    "Peso": "Peso",
    "IMC": "Índice de masa corporal",
    "Área de superfície corpórea": "Superficie corporal",
    "HAS": "Hipertensión",
    "DM": "Diabetes",
    "DM em uso de insulina": "Diabetes usando insulina",
    "DPOC": "Enfermedad pulmonar obstructiva crónica",
    "IAM prévio": "Infarto de miocardio previo",
    "AVE prévio": "Enfermedad cerebrovascular",
    "FA": "Fibrilación atrial",
    "Doença arterial obstrutiva periférica": "Enfermedad obstructiva arterial periférica",
    "pre_habilitacao": "Prehabilitación",
    "Esternotomia prévia": "Esternotomía previa",
    "Cirurgia cardíaca sem esternotomia prévia": "Cirugía cardiaca sin esternotomía previa",
    "Cirurgia torácica não cardíaca prévia": "Cirugía torácica no cardíaca previa",
    "Angioplastia prévia": "Angioplastia previa",
    "FEVE": "Fracción de eyección del ventrículo izquierdo",
    "Creatinina": "Creatinina",
    "NYHA": "Clasificación NYHA",
    "CCS": "Clasificación CCS",
    "EuroSCORE": "Riesgo de mortalidad operatoria según EuroSCORE",
    "STS": "Riesgo de mortalidad operatoria de la STS",
    "FRAIL scale": "Puntuación FRAIL score",
    "Uso de intubação seletiva": "Uso de ventilación pulmonar selectiva",
    "Método de intubação seletiva": "Método de ventilación unipulmonar",
    "Bloqueio regional": "Bloqueo anestésico regional",
    "Técnica de bloqueio regional": "Técnica de bloqueo regional",
    "Momento do bloqueio regional": "Momento del bloqueo regional",
    "Monitorização de débito minimamente invasiva": "Monitoreo de flujo mínimamente invasivo",
    "Monitor minimamente invasivo utilizado": "Se utiliza monitor mínimamente invasivo.",
    "Monitorização de débito invasiva": "Monitoreo de flujo invasivo",
    "Monitor invasivo utilizado": "Monitor invasivo utilizado",
    "Monitorização do Sistema Nervoso Central": "Monitoreo del sistema nervioso central",
    "Tipo de monitorizacão de SNC": "Tipo de monitorizacão de SNC",
    "Manutenção de ventilação durante a CEC": "Mantenimiento de la ventilación durante la CEC",
    "Consumo total de opioides": "Consumo total de opioides",
    "Uso de dexmedetomidina": "Uso de dexmedetomidina",
    "Extubação em sala": "Extubación en sala de operaciones",
    "Localização": "Localización",
    "Mediana": "Incisión media",
    "Tipo de esternotomia": "Tipo de esternotomía",
    "Lateralidade ": "Lateralidad",
    "Posição": "Posición de la incisión",
    "Tamanho da incisão": "Tamaño de la incisión",
    "Categoria do tamanho": "Categoría de tamaño",
    "Número de incisões adicionais": "Número de incisiones adicionales",
    "Incisão de trabalho na pele": "Incisión de trabajo de la piel",
    "Espaço intercostal aberto": "Espacio intercostal abierto",
    "Conversão para esternotomia": "Conversión a esternotomía",
    "Motivo da conversão": "Motivo de la conversión",
    "Estratégia de canulação": "Estrategia de canulación",
    "Método de canulação periférica": "Método de canulación periférica",
    "Assistência sem parada cardíaca": "Asistencia sin paro cardíaco",
    "Sítio de canulação arterial": "Sitio de canulación arterial",
    "Cânula arterial utilizada": "Cánula arterial utilizada",
    "Tamanho da cânula arterial": "Tamaño de la cánula arterial",
    "Estratégia de canulação venosa": "Estrategia de canulación venosa",
    "Cânula venosa única utilizada": "Se utiliza cánula venosa única",
    "Tamanho da cânula venosa única": "Tamaño de cánula venosa única",
    "Número de estágios da cânula única": "Número de etapas de la cánula única",
    "Cânula venosa superior utilizada": "Cánula venosa superior utilizada",
    "Tamanho da cânula venosa superior": "Tamaño de cánula venosa superior",
    "Cânula venosa inferior utilizada": "Se utiliza cánula venosa inferior.",
    "Tamanho da cânula venosa inferior": "Tamaño de la cánula venosa inferior.",
    "Laçamento das cavas": "Cordón de la vena cava",
    "Descompressão de câmaras esquerdas": "Descompresión de cámaras izquierdas",
    "Tipo de clampeamento": "Tipo de pinzamiento aórtico",
    "Perfusão cerebral seletiva": "Perfusión cerebral selectiva",
    "Tempo de CEC": "Tiempo de CEC",
    "Tempo de anóxia/clampeamento": "Anoxia/tiempo de pinzamiento aórtico",
    "Tempo de perfusão cerebral seletiva": "Tiempo de perfusión cerebral selectiva",
    "Tempo total da cirurgia": "Tiempo total de cirugía",
    "Cardioplegia utilizada": "Cardioplejía utilizada",
    "Necessidade de repetir cardioplegia": "Necesidad de repetir la cardioplejía",
    "Tipo de infusão da cardioplegia": "Tipo de infusión de cardioplejía",
    "Temperatura mínima em CEC (ºC)": "Temperatura mínima en CEC (ºC)",
    "Fluxo alvo da CEC (ml/min)": "Flujo objetivo de CEC (ml/min)",
    "Necessidade de assistência para saída de CEC": "Necesidad de asistencia para salir de CEC",
    "Assistência utilizada na saída de CEC": "Asistencia mecánica utilizada al salir del CEC",
    "Uso de miniCEC": "Uso de minCEC",
    "Revascularização": "Cirugía de revascularización miocárdica",
    "Abordagem valvar": "Cirugía valvular",
    "Abordagem da Aorta": "Cirugía de aorta",
    "abordagem_aorta":  "Cirugía de aorta",
    "correcao_cardiopatia_congenita" : "Corrección de cardiopatías congénitas",
    "outros_procedimentos_cardiacos": "Otros procedimientos cardíacos",
    "uso_videotoracoscopia": "Uso de Videotoracoscopia",
    "uso_plataforma_robotica" : "Uso de Plataforma Robótica",
    "Street": "Calle",
    "Number": "Número",
    "Complement": "Complemento",
    "Neighborhood": "Barrio",
    "City": "Ciudad",
    "State": "Estado",
    "password_strength_error": "La contraseña debe tener al menos 8 caracteres, incluidas letras mayúsculas, minúsculas, números y caracteres especiales.",
    "Correção de cardiopatia congênita": "Corrección de cardiopatías congénitas",
    "Outros Procedimentos Cardíacos": "Otros procedimientos cardíacos",
    "Uso de videotoracoscopia": "Uso de videotoracoscopia",
    "Uso de plataforma robótica": "Uso de plataforma robótica",
    "Plataforma robótica utilizada": "Plataforma robótica utilizada",
    "Revascularização com CEC": "Revascularización con CEC",
    "Número de coronárias acometidas": "Número de arterias coronarias afectadas",
    "Número de coronárias abordadas": "Número de arterias coronarias abordadas",
    "Número de enxertos utilizados": "Número de injertos utilizados",
    "Uso da mamária esquerda": "Utilización de la arteria arteria toracica interna izquierda",
    "Método de dissecção da mamária esquerda": "Método de disección arteria toracica internaizquierda",
    "Material utilizado na dissecção da mamária esquerda": "Material utilizado en la disección de la arteria toracica interna izquierda.",
    "Uso da mamária direita": "Uso de la arteria torácica interna derecha",
    "Método de dissecção da mamária direita": "Método de disección arteria torácica interna derecha",
    "Material utilizado na dissecção da mamária direita": "Material utilizado en la disección de la arteria toracica interna derecha",
    "Uso de A. radial": "Uso de la arteria radial",
    "Retirada endoscópica da radial": "Obtención endoscópica de la arteria radial",
    "Uso de A. gastroepiploica": "Extracción de la arteria gastroepiploica",
    "Uso de A. epigástrica inferior": "Inferior epigastric artery harvesting",
    "Uso de V. safena magna": "Uso de injerto de vena safena",
    "Uso da técnica safena no-touch": "Uso de la técnica de retirada de la safena sin contacto",
    "Retirada endoscópica da safena": "Extirpación endoscópica de la vena safena",
    "Uso de enxertos compostos": "Uso de injertos compuestos.",
    "Uso de ténica em Y": "Uso de la técnica en Y",
    "Uso de anastomoses sequenciais": "Uso de anastomosis secuenciales",
    "Uso de estabilizador cardíaco": "Uso de estabilizador cardíaco",
    "Estabilizador utilizado": "Estabilizador usado",
    "Uso de posicionador cardíaco": "Uso del posicionador cardíaco",
    "Posicionador utilizado": "Posicionador usado",
    "Material utilizado na anastomose coronariana": "Material utilizado en la anastomosis coronaria.",
    "Marca do material de mini utilizado": "Marca del mini material utilizado",
    "Angioplastia programada (cirurgia híbrida)": "Angioplastia programada (cirugía híbrida)",
    "Abordagem da Valva Aórtica": "Abordaje de la válvula aórtica",
    "Técnica de plastia valvar aórtica": "Técnica de reparación de la válvula aórtica",
    "Insuficiência aórtica pós-CEC": "Insuficiencia aórtica después de la CEC",
    "Prótese valvar aórtica": "Prótesis valvular aórtica",
    "Tamanho da prótese valvar aórtica": "Tamaño de la prótesis valvular aórtica",
    "Prótese de liberação rápida aórtica": "Prótesis aórtica de liberación rápida",
    "Uso de prótese aórtica endovascular": "Uso de prótesis aórtica endovascular",
    "Prótese aórtica com tratamento anticalcificante": "Prótesis aórtica con tratamiento anticalcificante",
    "Especificações da prótese aórtica": "Especificaciones de la prótesis aórtica",
    "Leak paravalvar aórtico": "Fuga paravalvular aórtica",
    "Abordagem da Valva Mitral": "Abordaje de la válvula mitral",
    "Via de acesso da valva mitral": "Vía de acceso a la válvula mitral",
    "Plastia valvar mitral": "Reparación de válvula mitral",
    "Troca valvar mitral": "Reemplazo de válvula mitral",
    "Comissurotomia mitral": "Comisurotomía mitral",
    "Uso de neocorda": "Uso de neocord",
    "Especificações da neocorda": "Especificaciones de Neocord",
    "Uso de anel mitral": "Uso del anillo mitral",
    "Especificações do anel mitral": "Especificaciones del anillo mitral",
    "Ressecção de folheto mitral": "Resección del velo mitral",
    "Anuloplastia posterior mitral": "Anuloplastia mitral posterior",
    "Gradiente médio da valva mitral pós-CEC": "Gradiente medio de válvula mitral post-CEC",
    "Insuficiência mitral pós-CEC": "Insuficiencia mitral post-CEC",
    "Prótese valvar mitral": "Prótesis de válvula mitral",
    "Tamanho da Prótese Valvar Mitral": "Tamaño de la prótesis de válvula mitral",
    "Prótese de liberação rápida mitral": "Prótesis mitral de liberación rápida",
    "Uso de prótese mitral endovascular": "Uso de prótesis mitral endovascular",
    "Prótese mitral com tratamento anticalcificante": "Prótesis mitral con tratamiento anticalcificante",
    "Especificações da prótese mitral": "Especificaciones de la prótesis mitral",
    "Leak paravalvar mitral": "Fuga paravalvular mitral",
    "Fechamento de auriculeta esquerda": "Oclusión de la auricula izquierda",
    "Abordagem da Valva Pulmonar": "Abordaje de válvula pulmonar",
    "Plastia valvar pulmonar": "Reparación de válvula pulmonar",
    "Troca valvar pulmonar": "Reemplazo de válvula pulmonar",
    "Técnica de plastia valvar pulmonar": "Técnica de reparación de válvula pulmonar.",
    "Gradiente médio valvar pulmonar pós-CEC": "Gradiente medio de válvula pulmonar post-CEC",
    "Insuficiência pulmonar pós-CEC": "Insuficiencia pulmonar post-CEC",
    "Prótese valvar pulmonar": "Prótesis de válvula pulmonar",
    "Tamanho da prótese valvar pulmonar": "Tamaño de la prótesis de válvula pulmonar",
    "Prótese de liberação rápida pulmonar": "Prótesis pulmonar de liberación rápida",
    "Uso de prótese pulmonar endovascular": "Uso de prótesis pulmonar endovascular.",
    "Prótese pulmonar com tratamento anticalcificante": "Prótesis pulmonar con tratamiento anticalcificante",
    "Especificações da prótese pulmonar": "Especificaciones de la prótesis pulmonar.",
    "Leak paravalvar pulmonar": "Fuga paravalvular pulmonar",
    "Abordagem da Valva Tricúspide": "Abordaje de la válvula tricúspide",
    "Plastia valvar tricúspide": "Reparación de válvula tricúspide",
    "Troca valvar tricúspide": "Reemplazo de válvula tricúspide",
    "Técnica de plastia valvar tricúspide": "Técnica de reparación de la válvula tricúspide",
    "Especificações do anel tricúspide": "Especificaciones del anillo tricúspide",
    "Gradiente médio valvar tricúspide pós-CEC": "Gradiente medio de válvula tricúspide post-CEC",
    "Insuficiência valvar tricúspide pós-CEC": "Insuficiencia de la válvula tricúspide post-CEC",
    "Prótese valvar tricúspide": "Prótesis de válvula tricúspide",
    "Tamanho da prótese valvar tricúspide": "Tamaño de la prótesis de válvula tricúspide",
    "Prótese de liberação rápida tricúspide": "Prótesis tricúspide de liberación rápida",
    "Uso de prótese tricúspide endovascular": "Uso de prótesis tricúspide endovascular",
    "Prótese tricúspide com tratamento anticalcificante": "Prótesis tricúspide con tratamiento anticalcificante",
    "Especificações da prótese tricúspide": "Especificaciones de la prótesis tricúspide",
    "Leak paravalvar tricúspide": "Fuga paravalvular tricúspide",
    "Segmentos da aorta abordados": "Segmentos aórticos cubiertos",
    "Reimplante de coronárias": "Reimplantación coronaria",
    "Preservação da valva aórtica nativa": "Preservación de la válvula aórtica nativa.",
    "Uso de tubo sintético": "Uso de tubo sintético",
    "Tamanho do Tubo Sintético": "Tamaño del tubo sintético",
    "Uso de tubo valvado": "Uso de tubo valvado",
    "Tipo de valva do tubo valvado": "Tipo de válvula en el injerto compuesto",
    "Especificações do material utilizado na Aorta": "Especificaciones del material utilizado en Aorta",
    "Programação de Procedimento Híbrido": "Programación de procedimientos híbridos",
    "Cardiopatia congênita abordada": "Se abordan las cardiopatías congénitas",
    "Uso de pericárdio": "Uso de pericardio",
    "Uso de afastador de partes moles": "Uso de retractor de tejidos blandos.",
    "Especificações do afastador de partes moles": "Especificaciones del retractor de tejidos blandos.",
    "Luxação, fratura de costelas/articulação costocondral": "Dislocación, fractura de costillas/articulación costocondral",
    "Uso de fixação rígida": "Uso de fijación rígida.",
    "Sítio da fixação rígida": "Sitio de fijación rígido",
    "Especificações da prótese de fixação rígida": "Especificaciones de prótesis de fijación rígida",
    "Pericardiotomia posterior esquerda": "Pericardiotomía posterior izquierda",
    "Drenagem pericárdica": "Drenaje pericárdico",
    "Drenagem pleural": "Drenaje pleural",
    "Tipo de dreno pleural utilizado": "Tipo de drenaje pleural utilizado",
    "Tempo de extubação após admissão na UTI": "Tiempo de extubación tras el ingreso en UCI",
    "Tempo de permanência em Unidade de Terapia Intensiva": "Duración de la estancia en la Unidad de Cuidados Intensivos",
    "Tempo de permanência em internação Hospitalar": "Duración de la estancia en el hospital",
    "Dor pós-operatória relatada": "Dolor postoperatorio informado",
    "Escala visual analógica da dor": "Escala visual analógica del dolor.",
    "Tempo para início de mobilização no leito": "Tiempo hasta la movilización en cama",
    "Tempo para início de deambulação": "Tiempo hasta caminar",
    "Infecção": "Infección",
    "Deiscência de ferida operatória ": "Dehiscencia de herida quirúrgica",
    "Infarto do miocárdio pós-operatório": "Infarto de miocardio posoperatorio",
    "Necessidade de nova revascularização não programada durante internação ": "Necesidad de nueva revascularización no programada durante la hospitalización",
    "Derrame pleural": "Derrame pleural",
    "Tamponamento cardíaco": "Taponamiento cardíaco",
    "Necessidade de primeira diálise": "Necesidad de primera diálisis",
    "AVE novo com sequela": "Accidente cerebrovascular posoperatorio",
    "Fibrilação Atrial pós-operatória": "Fibrilación atrial postoperatoria",
    "Parada cardiorrespiratória revertida no pós-operatório": "Paro cardiorrespiratorio revertido postoperatoriamente",
    "Necessidade de Dispositivo de Assistência Circulatória no pós-operatório": "Necesidad de un Dispositivo de Asistencia Circulatoria en el postoperatorio",
    "Tipo de dispositivo de assistência circulatória ": "Tipo de dispositivo de asistencia circulatoria",
    "Tempo para início da retirada dos drenos (horas)": "Tiempo para iniciar la extracción del drenaje (horas)",
    "Readmissão hospitalar": "Reingreso hospitalario",
    "Transfusão de hemoderivados": "Transfusión de productos sanguíneos.",
    "Momento da transfusão": "Momento de la transfusión",
    "Elemento transfundido": "Elemento transfundido",
    "Óbito intra-hospitalar": "Muerte intrahospitalaria",
    "Motivo do óbito": "Motivo de la muerte",
    "Momento do óbito": "hora de la muerte",
    "Óbito durante seguimento": "Muerte durante el seguimiento.",
    "Tempo do óbito após cirurgia (dias)": "Tiempo de muerte después de la cirugía (días)",
    Exportacao_info_1: "Quer incluir dados de outros formulários?",
    Exportacao: "Exportação",
    Exportar: "Exportar",
    esqueceu_sua_senha: "¿Olvidaste tu contraseña?",
    Users: "Usuarios",
    Institution_Registration: "Registro de institución",
    Institution: "Institución",
    Name_of_Institution: "Nombre de la Institución",
    ZIP_Code: "Código postal de la institución",
    "Register_Success": "Registro completado con éxito",
    Institution_Address: "Dirección de la institución",
    Institution_Telephone_Number: "Número de teléfono de la institución",
    CNES: "CNES de la Institución",
    Responsible: "Responsable",
    Name_Responsible: "Nombre",
    Email_Responsible: "Correo electrónico",
    Telefone_Ramal_Responsible: "Teléfono",
    Password: "Contraseña",
    Password_info: "Utilice 8 o más caracteres con una combinación de letras, números y símbolos.",
    Confirm_Password: "Confirmar la contraseña",
    Register: "Registro",
    Already_Registered: "¿Ya estás registrado?",
    language: "Idioma",
    welcome: "Bienvenido Cardux MICS",
    welcome_p2: "¡Por favor introduce tus datos de acceso!",
    user: "Usuario",
    password: "Contraseña",
    "date_invalid": "Fecha inválida. Verifique el día, mes y año.",
    "day_invalid": "Día inválido para el mes informado.",
    "date_future": "La fecha no puede ser en el futuro.",
    "date_past": "La fecha de nacimiento es muy antigua.",
    remember_me: "Lembra de mim",
    invalid_data: "Datos no válidos",
    login: "Acceso",
    dashboard: "Panel",
    "Select_Instituicao": "Seleccione la Hospital",
    "ID_Paciente": "ID del paciente",
    "Instituicao_ID" : "ID en Hospital",
    new_patient_registration: "Registro de nuevos pacientes",
    my_patients: "Mis pacientes",
    generate_report: "Generar informe",
    my_summary: "Mi resumen",
    surgeries: "Cirugías",
    times: "Veces",
    survival: "Supervivencia",
    hours: "horas",
    days: "días",
    in_30_days: "en 30 dias",
    IOT_h: "IOT",
    IOT_p: "Tiempo hasta la extubación",
    UTI_h: "UTI",
    UTI_p: "tiempo de UCI",
    LOS_h: "LOS",
    LOS_p: "Duración de la estancia",
    logoff: "Salir",
    Records: "Archivos",
    no_records_found: "no se encontraron registros",
    Details: "Detalles",
    Voltar: "Volver",
    "Create": "Crear",
    "Update": "Actualizar",
    "Institutions": "Hospital",
    nome: "Nombre",
    hospital: "Hospital",
    Criar_Paciente: "Crear paciente",
    Categories: "Categorías",
    Form_for: "Formulario para",
    Salvar: "Ahorrar",
    identificacao: "Identificación",
    pre_operatorio: "Preoperatorio",
    escores: "Montones",
    anestesia: "Anestesia",
    incisao: "Incisión",
    circulacao_extracorporea: "Circulación extracorpórea",
    cirurgia: "Cirugía",
    pos_operatorio: "Postoperatorio",
    hemotransfusao: "Transfusión de sangre",
    obito: "Muerte",
    sim: "Sí",
    nao: "No",
    id_do_paciente: "ID del paciente",
    id_no_hospital: "ID en Hospital",
    cpf: "CPF",
    idade: "Idade",
    sexo: "Sexo",
    altura_cm: "Altura (cm)",
    altura_m: "Altura (m)",
    "altura": "Altura",
    "peso": "Peso",
    "Os seguintes campos são obrigatórios:": "Los siguientes campos son obligatorios:",
    "data_nascimento": "Fecha de Nacimiento",
    "Confirmar_salvar": "¿Le gustaría confirmar su cambio?",
    peso_g: "Peso (g)",
    peso_kg: "Peso (kg)",
    imc: "IMC",
    asc_m2: "ASC (m2)",
    has: "HAS",
    dm: "DM",
    DMid: "Diabetes usando insulina",
    dpoc: "DPOC",
    iam_previo: "IAM prévio",
    ave_previo: "AVE prévio",
    fa_pre_operatoria: "FA pré-operatória",
    DAOP: "Enfermedad Arterial Obstructiva Periférica",
    pre_habilitado: "Pré-habilitado",
    "Cirurgia torácica prévia": "Cirugía torácica previa",
    feve_porcenta: "FEVE (%)",
    creatinina_mg_dl: "Creatinina (mg/dl)",
    angioplastia_previa: "Angioplastia prévia",
    nyha: "NYHA",
    ccs: "CCS",
    euroscore_porcenta: "EUROscore (%)",
    sts_score_porcenta: "STS score (%)",
    "Frail score": "Índice de fragilidad",
    uso_de_intubacao_seletiva: "Uso de intubação seletiva",
    metodo_de_intubacao_seletiva: "Método de intubação seletiva",
    bloqueio_regional: "Bloqueio regional",
    tecnica_de_bloqueio_regional: "Técnica de bloqueio regional",
    momento_do_bloqueio_regional: "Momento do bloqueio regional",
    monitorizacao_de_debito_minimamente_invasiva: "Monitorização de débito minimamente invasiva",
    monitor_minimamente_invasivo_utilizado: "Monitor minimamente invasivo utilizado",
    monitorizacao_de_debito_invasiva: "Monitorização de débito invasiva",
    monitor_invasivo_utilizado: "Monitor invasivo utilizado",
    monitorizacao_de_snc: "Monitorização de SNC",
    tipo_de_monitorizacao_de_snc: "Tipo de monitorizacão de SNC",
    manutencao_de_ventilacao_durante_a_cec: "Manutenção de ventilação durante a CEC",
    consumo_total_de_opioides: "Consumo total de opioides",
    uso_de_dexmedetomidina: "Uso de dexmedetomidina",
    extubacao_em_sala: "Extubação em sala",
    localizacao: "Localização",
    mediana: "Mediana",
    tipo_de_esternotomia: "Tipo de esternotomia",
    lateralidade_se_nao_mediana: "Lateralidade (se não mediana)",
    posicao_se_nao_mediana: "Posição (se não mediana)",
    tamanho_da_incisao_cm: "Tamanho da incisão (cm)",
    categoria_do_tamanho: "Categoria do tamanho",
    numero_de_incisoes_adicionais: "Número de incisões adicionais",
    incisao_de_trabalho_na_pele_nao_mediana: "Incisão de trabalho na pele (não mediana)",
    espaco_intercostal_aberto_nao_mediana: "Espaço intercostal aberto (não mediana)",
    conversao_para_esternotomia: "Conversão para esternotomia",
    motivo_da_conversao: "Motivo da conversão",
    tipo_de_canulacao: "Tipo de canulação",
    metodo_de_canulacao_periferica: "Método de canulação periférica",
    assistencia_sem_parada_cardiaca_beating_heart: "Assistência sem parada cardíaca (beating heart)",
    canulacao_arterial: "Canulação arterial",
    canula_arterial_utilizada_marca_especificacao: "Cânula arterial utilizada (Marca/Especificação)",
    tamanho_da_canula_arterial_fr: "Tamanho da cânula arterial (Fr)",
    canulacao_venosa: "Canulação venosa",
    canula_venosa_unica_utilizada_marca_especificacao: "Cânula venosa única utilizada (Marca/Especificação)",
    tamanho_da_canula_venosa_unica_fr: "Tamanho da cânula venosa única (Fr)",
    numero_de_estagios_da_canula_unica: "Número de estágios da cânula única",
    canula_venosa_superior_utilizada_marca_especificacao: "Cânula venosa superior utilizada (Marca/Especificação)",
    tamanho_da_canula_venosa_superior_fr: "Tamanho da cânula venosa superior (Fr)",
    canula_venosa_inferior_utilizada_marca_especificacao: "Cânula venosa inferior utilizada (Marca/Especificação)",
    tamanho_da_canula_venosa_inferior_fr: "Tamanho da cânula venosa inferior (Fr)",
    lacamento_das_cavas: "Laçamento das cavas",
    tipo_de_clampeamento: "Tipo de clampeamento",
    perfusao_cerebral_seletiva: "Perfusão cerebral seletiva",
    tempo_de_cec_min: "Tempo de CEC (min)",
    tempo_de_anoxia_clampeamento_min: "Tempo de anóxia/clampeamento (min)",
    tempo_de_perfusao_cerebral_seletiva_min: "Tempo de perfusão cerebral seletiva (min)",
    tempo_total_da_cirurgia_min_de_pele_a_pele: "Tempo total da cirurgia (min, de pele a pele)",
    cardioplegia_utilizada: "Cardioplegia utilizada",
    necessidade_de_repetir_cardioplegia: "Necessidade de repetir cardioplegia",
    tipo_de_infusao_da_cardioplegia: "Tipo de infusão da cardioplegia",
    temperatura_minima_em_cec_posicaoc: "Temperatura mínima em CEC (ºC)",
    fluxo_alvo_da_cec_ml_min: "Fluxo alvo da CEC (ml/min)",
    necessidade_de_assistencia_para_saida_de_cec: "Necessidade de assistência para saída de CEC",
    assistencia_utilizada_na_saida_de_cec: "Assistência utilizada na saída de CEC",
    uso_de_minicec: "Uso de miniCEC",
    eretor_da_espinha: "eretor da espinha",
    paraesternal: "paraesternal",
    subcostal: "subcostal",
    intercostal: "intercostal",
    serratil_anterior: "serrátil anterior",
    pre_incisional: "pré-incisional",
    pos_incisional: "pós-incisional",
    na_uti: "na UTI",
    bis: "BIS",
    qnox: "QNox",
    nirs: "NIRS",
    doppler_transcraniano: "Doppler transcraniano",
    saturacao_venosa_jugular: "Saturação venosa jugular",
    "1posicao_eic": "1º EIC",
    "2posicao_eic": "2º EIC",
    "3posicao_eic": "3º EIC",
    "4posicao_eic": "4º EIC",
    "5posicao_eic": "5º EIC",
    "6posicao_eic": "6º EIC",
    "7posicao_eic": "7º EIC",
    "8posicao_eic": "8º EIC",
    revascularizacao: "Revascularização",
    abordagem_da_aorta: "Abordagem da Aorta",
    correcao_de_cardiopatia_congenita: "Correção de cardiopatia congênita",
    uso_de_videotoracoscopia: "Uso de videotoracoscopia",
    transplante_cardiaco: "Transplante Cardíaco",
    implante_de_eletrodo_epicardico: "Implante de eletrodo epicárdico",
    janela_pleuropericardica: "Janela pleuropericárdica",
    pericardiectomia: "pericardiectomia",
    cox_maze: "Cox Maze",
    fechamento_de_auriculeta: "Fechamento de auriculeta",
    uso_de_plataforma_robotica: "Uso de plataforma robótica",
    plataforma_robotica_utilizada: "Plataforma robótica utilizada",
    revascularizacao_com_cec: "Revascularização com CEC",
    numero_de_coronarias_acometidas: "Número de coronárias acometidas",
    numero_de_coronarias_abordadas: "Número de coronárias abordadas",
    numero_de_enxertos_utilizados: "Número de enxertos utilizados",
    uso_de_atie: "Uso de ATIE",
    metodo_de_disseccao_da_atie: "Método de dissecção da ATIE",
    material_utilizado_na_disseccao_da_atie: "Material utilizado na dissecção da ATIE",
    uso_de_atid: "Uso de ATID",
    pinca_de_coronaria_convencional: "Pinça de coronária convencional",
    pinca_de_mini: "Pinça de mini",
    tesoura_de_potts_dietrich_convencional: "Tesoura de Potts/Dietrich convencional",
    tesoura_de_mini: "Tesoura de mini",
    bisturi_eletrico_monopolar_convencional: "Bisturi elétrico monopolar convencional",
    bisturi_eletrico_com_extensor_de_lamina: "Bisturi elétrico com extensor de lâmina",
    bisturi_harmonico: "Bisturi harmônico",
    bisturi_eletrico_bipolar: "bisturi elétrico bipolar",
    bisturi_de_video_hook: "Bisturi de vídeo Hook",
    bisturi_ligasure: "Bisturi Ligasure",
    plataforma_robotica: "Plataforma robótica",
    metodo_de_disseccao_da_atid: "Método de dissecção da ATID",
    material_utilizado_na_disseccao_da_atid: "Material utilizado na dissecção da ATID",
    retirada_endoscopica_da_radial: "Retirada endoscópica da radial",
    uso_de_a_radial: "Uso de A. radial",
    uso_de_a_epigastrica_inferior: "Uso de A. epigástrica inferior",
    uso_de_a_gastroepiploica: "Uso de A. gastroepiploica",
    uso_de_v_safena_magna: "Uso de V. safena magna",
    uso_da_tecnica_safena_no_touch: "Uso da técnica safena no-touch",
    retirada_endoscopica_da_safena: "Retirada endoscópica da safena",
    uso_de_enxertos_compostos: "Uso de enxertos compostos",
    uso_de_tenica_em_y: "Uso de ténica em Y",
    uso_de_anastomoses_sequenciais: "Uso de anastomoses sequenciais",
    uso_de_estabilizador_cardiaco: "Uso de estabilizador cardíaco",
    estabilizador_utilizado: "Estabilizador utilizado",
    uso_de_posicionador_cardiaco: "Uso de posicionador cardíaco",
    posicionador_utilizado: "Posicionador utilizado",
    material_utilizado_na_anastomose_coronariana: "Material utilizado na anastomose coronariana",
    marca_do_material_de_mini_utilizado: "Marca do material de mini utilizado",
    castroviejo_mini: "Castroviejo Mini",
    castroviejo_convencional: "Castroviejo convencional",
    pinca_robotica: "Pinça robótica",
    porta_agulhas_robotica: "Porta-agulhas robótica",
    angioplastia_programada_cirurgia_hibrida: "Angioplastia programada (cirurgia híbrida)",
    abordagem_da_valva_aortica: "Abordagem da Valva Aórtica",
    plastia_valvar_aortica: "Plastia valvar aórtica",
    troca_valvar_aortica: "Troca valvar aórtica",
    tecnica_de_plastia_valvar_aortica: "Técnica de plastia valvar aórtica",
    gradiente_medio_valvar_aortico_pos_cec: "Gradiente Médio Valvar Aórtico Pós-CEC",
    insuficiencia_aortica_pos_cec: "Insuficiência aórtica pós-CEC",
    protese_valvar_aortica: "Prótese valvar aórtica",
    tamanho_da_protese_valvar_aortica: "Tamanho da prótese valvar aórtica",
    protese_de_liberacao_rapida_aortica: "Prótese de liberação rápida aórtica",
    uso_de_protese_aortica_endovascular: "Uso de prótese aórtica endovascular",
    protese_aortica_com_tratamento_anticalcificante: "Prótese aórtica com tratamento anticalcificante",
    especificacoes_da_protese_aortica: "Especificações da prótese aórtica",
    leak_paravalvar_aortico: "Leak paravalvar aórtico",
    abordagem_da_valva_mitral: "Abordagem da Valva Mitral",
    via_de_acesso_da_valva_mitral: "Via de acesso da valva mitral",
    plastia_valvar_mitral: "Plastia valvar mitral",
    troca_valvar_mitral: "Troca valvar mitral",
    comissurotomia_mitral: "Comissurotomia mitral",
    uso_de_neocorda: "Uso de neocorda",
    especificacoes_da_neocorda: "Especificações da neocorda",
    uso_de_anel_mitral: "Uso de anel mitral",
    especificacoes_do_anel_mitral: "Especificações do anel mitral",
    resseccao_de_folheto_mitral: "Ressecção de folheto mitral",
    anuloplastia_posterior_mitral: "Anuloplastia posterior mitral",
    gradiente_medio_da_valva_mitral_pos_cec: "Gradiente médio da valva mitral pós-CEC",
    insuficiencia_mitral_pos_cec: "Insuficiência mitral pós-CEC",
    protese_valvar_mitral: "Prótese valvar mitral",
    tamanho_da_protese_valvar_mitral: "Tamanho da Prótese Valvar Mitral",
    protese_de_liberacao_rapida_mitral: "Prótese de liberação rápida mitral",
    uso_de_protese_mitral_endovascular: "Uso de prótese mitral endovascular",
    protese_mitral_com_tratamento_anticalcificante: "Prótese mitral com tratamento anticalcificante",
    especificacoes_da_protese_mitral: "Especificações da prótese mitral",
    leak_paravalvar_mitral: "Leak paravalvar mitral",
    fechamento_de_auriculeta_esquerda: "Fechamento de auriculeta esquerda",
    abordagem_da_valva_pulmonar: "Abordagem da Valva Pulmonar",
    plastia_valvar_pulmonar: "Plastia valvar pulmonar",
    troca_valvar_pulmonar: "Troca valvar pulmonar",
    tecnica_de_plastia_valvar_pulmonar: "Técnica de plastia valvar pulmonar",
    gradiente_medio_valvar_pulmonar_pos_cec: "Gradiente médio valvar pulmonar pós-CEC",
    insuficiencia_pulmonar_pos_cec: "Insuficiência pulmonar pós-CEC",
    protese_valvar_pulmonar: "Prótese valvar pulmonar",
    tamanho_da_protese_valvar_pulmonar: "Tamanho da prótese valvar pulmonar",
    protese_de_liberacao_rapida_pulmonar: "Prótese de liberação rápida pulmonar",
    uso_de_protese_pulmonar_endovascular: "Uso de prótese pulmonar endovascular",
    protese_pulmonar_com_tratamento_anticalcificante: "Prótese pulmonar com tratamento anticalcificante",
    especificacoes_da_protese_pulmonar: "Especificações da prótese pulmonar",
    leak_paravalvar_pumonar: "Leak paravalvar pumonar",
    abordagem_da_valva_tricuspide: "Abordagem da Valva Tricúspide",
    plastia_valvar_tricuspide: "Plastia valvar tricúspide",
    troca_valvar_tricuspide: "Troca valvar tricúspide",
    tecnica_de_plastia_valvar_tricuspide: "Técnica de plastia valvar tricúspide",
    especificacoes_do_anel_tricuspide: "Especificações do anel tricúspide",
    gradiente_medio_valvar_tricuspide_pos_cec: "Gradiente médio valvar tricúspide pós-CEC",
    insuficiencia_valvar_tricuspide_pos_cec: "Insuficiência valvar tricúspide pós-CEC",
    protese_valvar_tricuspide: "Prótese valvar tricúspide",
    tamanho_da_protese_valvar_tricuspide: "Tamanho da prótese valvar tricúspide",
    protese_de_liberacao_rapida_tricuspide: "Prótese de liberação rápida tricúspide",
    uso_de_protese_tricuspide_endovascular: "Uso de prótese tricúspide endovascular",
    protese_tricuspide_com_tratamento_anticalcificante: "Prótese tricúspide com tratamento anticalcificante",
    especificacoes_da_protese_tricuspide: "Especificações da prótese tricúspide",
    leak_paravalvar_tricuspide: "Leak paravalvar tricúspide",
    segmentos_da_aorta_abordados: "Segmentos da aorta abordados",
    reimplante_de_coronarias: "Reimplante de coronárias",
    preservacao_da_valva_aortica_nativa: "Preservação da valva aórtica nativa",
    uso_de_tubo_sintetico: "Uso de tubo sintético",
    tamanho_do_tubo_sintetico_mm: "Tamanho do Tubo Sintético (mm)",
    uso_de_tubo_valvado: "Uso de tubo valvado",
    tipo_de_valva_do_tubo_valvado: "Tipo de valva do tubo valvado",
    especificacoes_do_material_utilizado_na_aorta: "Especificações do material utilizado na Aorta",
    programacao_de_procedimento_hibrido: "Programação de Procedimento Híbrido",
    cardiopatia_congenita_abordada: "Cardiopatia congênita abordada",
    uso_de_pericardio: "Uso de pericárdio",
    uso_de_afastador_de_partes_moles: "Uso de afastador de partes moles",
    especificacoes_do_afastador_de_partes_moles: "Especificações do afastador de partes moles",
    uso_de_fixacao_rigida: "Uso de fixação rígida",
    sitio_da_fixacao_rigida: "Sítio da fixação rígida",
    especificacoes_da_protese_de_fixacao_rigida: "Especificações da prótese de fixação rígida",
    pericardiotomia_posterior_esquerda: "Pericardiotomia posterior esquerda",
    drenagem_pericardica: "Drenagem pericárdica",
    drenagem_pleural: "Drenagem pleural",
    tipo_de_dreno_pleural_utilizado: "Tipo de dreno pleural utilizado",
    tempo_de_permanencia_em_unidade_de_terapia_intensiva_horas: "Tempo de permanência em Unidade de Terapia Intensiva (horas)",
    tempo_de_permanencia_em_internacao_hospitalar_dias: "Tempo de permanência em internação Hospitalar (dias)",
    tempo_de_extubacao_apos_admissao_na_uti_horas: "Tempo de extubação após admissão na UTI (horas)",
    dor_pos_operatoria: "Dor pós-operatória",
    escala_visual_analogica_da_dor: "Escala visual analógica da dor",
    tempo_para_inicio_de_mobilizacao_no_leito_horas: "Tempo para início de mobilização no leito (horas)",
    tempo_para_inicio_de_deambulacao_horas: "Tempo para início de deambulação (horas)",
    infeccao: "Infecção",
    deiscencia_de_ferida_operatoria_: "Deiscência de ferida operatória ",
    infarto_do_miocardio_pos_operatorio: "Infarto do miocárdio pós-operatório",
    necessidade_de_nova_revascularizacao_nao_programada_durante_internacao_: "Necessidade de nova revascularização não programada durante internação ",
    necessidade_de_primeira_dialise: "Necessidade de primeira diálise",
    ave_novo_com_sequela: "AVE novo com sequela",
    fibrilacao_atrial_pos_operatoria: "Fibrilação Atrial pós-operatória",
    parada_cardiorrespiratoria_revertida_no_pos_operatorio: "Parada cardiorrespiratória revertida no pós-operatório",
    necessidade_de_dispositivo_de_assistencia_circulatoria_no_pos_operatorio: "Necessidade de Dispositivo de Assistência Circulatória no pós-operatório",
    tipo_de_dispositivo_de_assistencia_circulatoria_: "Tipo de dispositivo de assistência circulatória ",
    tempo_para_inicio_da_retirada_dos_drenos_horas: "Tempo para início da retirada dos drenos (horas)",
    transfusao_de_hemoderivados: "Transfusão de hemoderivados",
    momento_da_transfusao: "Momento da transfusão",
    elemento_transfundido: "Elemento transfundido",
    obito_intra_hospitalar: "Óbito intra-hospitalar",
    motivo_do_obito: "Motivo do óbito",
    momento_do_obito: "Momento do óbito",
    obito_durante_seguimento: "Óbito durante seguimento",
    tempo_do_obito_apos_cirurgia_dias: "Tempo do óbito após cirurgia (dias)",
    sem_canulacao: "Sem canulação",
    periferica: "Periférica",
    central: "Central",
    mista: "Mista",
    puncao: "Punção",
    disseccao: "Dissecção",
    puncao_por_visao_direta: "Punção por visão direta",
    aorta_ascendente: "Aorta ascendente",
    arco_aortico: "Arco aórtico",
    tronco_braquiocefalico: "Tronco braquiocefálico",
    axilar: "Axilar",
    subclavia: "Subclávia",
    carotidea: "Carotídea",
    femoral: "Femoral",
    iliaca_externa: "Ilíaca externa",
    campo_aberto: "CAMPO ABERTO",
    "0_50": "[0;50]",
    atrial_unica: "Atrial única",
    bicaval: "Bicaval",
    femoral_unica: "Femoral única",
    jugular_unica: "Jugular única",
    jugular__femoral: "Jugular + femoral",
    cava_superior__femoral: "Cava superior + femoral",
    bicaval__cava_esquerda: "Bicaval + cava esquerda",
    outra: "Outra",
    estagio_unico: "Estágio único",
    duplo_estagio: "Duplo estágio",
    triplo_estagio: "Triplo estágio",
    sem_clampeamento: "Sem clampeamento",
    convencional: "Convencional",
    endoclamp: "Endoclamp",
    chitwood: "Chitwood",
    "0_2000": "[0;2000]",
    "0_1000": "[0;1000]",
    cirurgia_em_assistencia: "Cirurgia em assistência",
    del_nido: "Del Nido",
    custodiol: "Custodiol",
    anterograda: "anterógrada",
    retrograda: "retrógrada",
    combinada: "combinada",
    "10_40": "[10;40]",
    "0_10000": "[0;10000]",
    balao_intra_aortico: "Balão intra-aórtico",
    centrimag: "Centrimag",
    ecmo_va: "ECMO VA",
    ecmo_vv: "ECMO VV",
    berlin_heart: "Berlin Heart",
    heartmate: "HeartMate",
    identificacao_description: "Formulário que coleta dados básicos de identificação do paciente",
    pre_operatorio_description: "Avaliação prévia à cirurgia, com foco em exames e preparação do paciente",
    escores_description: "Coleta de escores clínicos para avaliação do estado de saúde do paciente",
    anestesia_description: "Informações sobre o processo anestésico e sedação do paciente",
    incisao_description: "Registro do início da cirurgia, com detalhes sobre a incisão",
    circulacao_extracorporea_description: "Informações sobre o uso da circulação extracorpórea durante a cirurgia",
    cirurgia_description: "Detalhes do procedimento cirúrgico principal realizado no paciente",
    pos_operatorio_description: "Monitoramento e cuidados imediatos no pós-operatório",
    hemotransfusao_description: "Registro de transfusões sanguíneas realizadas durante ou após a cirurgia",
    obito_description: "Registro de informações relacionadas ao falecimento do paciente",
    "Confirmar": "Confirmar",
    "Yes": "Sí",
    "No": "No",
    "Operacao_cancelada": "Operación cancelada",
    "Edit_Anestesia": "Editar anestesia",
    "Add_Anestesia": "Agregar anestesia",
    "Robertshaw": "Robertshaw",
    "Sonda de oclusão brônquica": "Sonda de oclusión bronquial",
    "Eretor da espinha": "Erector de la columna",
    "Paraesternal": "Paraesternal",
    "Subcostal": "Subcostal",
    "Intercostal": "Intercostal",
    "Serrátil anterior": "Serrato anterior",
    "Pré-incisional": "Preincisional",
    "Pós-incisional": "Postincisional",
    "Na UTI": "En la UCI",
    "FloTrac/Vigileo": "FloTrac/Vigileo",
    "PICCO": "PICCO",
    "LidCO": "LidCO",
    "Swan-Ganz": "Swan-Ganz",
    "Termodiluição transpulmonar": "Termodilución transpulmonar",
    "Monitorização de SNC": "Monitoreo de SNC",
    "Tipo de monitorização de SNC": "Tipo de monitoreo de SNC",
    "BIS": "BIS",
    "QNox": "QNox",
    "NIRS": "NIRS",
    "Doppler transcraniano": "Doppler transcraneal",
    "Saturação venosa jugular": "Saturación venosa yugular",
    "Selecione": "Seleccione",
    "Sim": "Sí",
    "Edit_PreOperatorio": "Editar preoperatorio",
    "Add_PreOperatorio": "Agregar preoperatorio",
    "Select_Sexo": "Seleccione género",
    "Masculino": "Masculino",
    "Feminino": "Femenino",
    "ASC": "ASC",
    "Edit_Escore": "Edit Score",
    "Add_Escore": "Add Score",
    "EUROscore (%)": "EUROscore (%)",
    "STS score (%)": "STS score (%)",
    "euroscore": "EUROscore",
    "sts_score": "STS score",
    "uso_intubacao_seletiva": "Uso de intubación selectiva",
    "monitorizacao_debito_min_invasiva": "Monitoreo de débito mínimamente invasivo",
    "monitorizacao_debito_invasiva": "Monitoreo de débito invasivo",
    "monitorizacao_snc": "Monitoreo de SNC",
    "manutencao_ventilacao_cec": "Mantenimiento de ventilación durante la CEC",
    "consumo_total_opioides": "Consumo total de opioides",
    "uso_dexmedetomidina": "Uso de dexmedetomidina",
    "Edit_Incisao": "Editar Incisión",
    "Add_Incisao": "Agregar Incisión",
    "Lateralidade": "Lateralidad",
    "Endoscópica <= 2cm": "Endoscópica <= 2cm",
    "Microincisão 2-4cm": "Microincisión 2-4cm",
    "Miniincisão 4-6cm": "Miniincisión 4-6cm",
    "Convencional >= 6cm": "Convencional >= 6cm",
    "tamanho_incisao": "Tamaño de la incisión",
    "conversao_esternotomia": "Conversión a esternotomía",
    "Esternotomia": "Esternotomía",
    "Miniesternotomia em J": "Miniesternotomía en J",
    "Miniesternotomia em L": "Miniesternotomía en L",
    "Toracotomia anterior direita": "Toracotomía anterior derecha",
    "Toracotomia axilar direita": "Toracotomía axilar derecha",
    "Toracotomia periareolar direita / MAMICS": "Toracotomía periareolar derecha / MAMICS",
    "Toracotomia anterolateral esquerda": "Toracotomía anterolateral izquierda",
    "Toracotomia lateral esquerda": "Toracotomía lateral izquierda",
    "Sem esternotomia": "Sin esternotomía",
    "Completa/Convencional": "Completa/Convencional",
    "Parcial em J": "Parcial en J",
    "Parcial em L": "Parcial en L",
    "Parcial em T invertido": "Parcial en T invertida",
    "Parcial em T": "Parcial en T",
    "H deitado": "H tumbado",
    "Esquerda": "Izquierda",
    "Direita": "Derecha",
    "Anterior": "Anterior",
    "Anterolateral": "Anterolateral",
    "Lateral/Axilar": "Lateral/Axilar",
    "1º EIC": "1º EIC",
    "2º EIC": "2º EIC",
    "3º EIC": "3º EIC",
    "4º EIC": "4º EIC",
    "5º EIC": "5º EIC",
    "6º EIC": "6º EIC",
    "7º EIC": "7º EIC",
    "8º EIC": "8º EIC",
    "Tipo de canulação": "Tipo de canulación",
    "Sem canulação": "Sin canulación",
    "Periférica": "Periférica",
    "Central": "Central",
    "Mista": "Mixta",
    "Sem clampeamento": "Sin clampeo",
    "Convencional": "Convencional",
    "Endoclamp": "Endoclamp",
    "Chitwood": "Chitwood",
    "Punção": "Punción",
    "Dissecção": "Disección",
    "Punção por visão direta": "Punción por visión directa",
    "Canulação arterial": "Canulación arterial",
    "Aorta ascendente": "Aorta ascendente",
    "Arco aórtico": "Arco aórtico",
    "Tronco braquiocefálico": "Tronco braquiocefálico",
    "Axilar": "Axilar",
    "Subclávia": "Subclavia",
    "Carotídea": "Carótida",
    "Femoral": "Femoral",
    "Ilíaca externa": "Ilíaca externa",
    "Estágio único": "Etapa única",
    "Duplo estágio": "Doble etapa",
    "Triplo estágio": "Triple etapa",
    "Multiperfurada": "Multiperforada",
    "Balão intra-aórtico": "Globo intraaórtico",
    "Centrimag": "Centrimag",
    "ECMO VA": "ECMO VA",
    "ECMO VV": "ECMO VV",
    "Berlin Heart": "Berlin Heart",
    "HeartMate": "HeartMate",
    "Edit_CirculacaoExtracorporea": "Editar Circulación Extracorpórea",
    "Add_CirculacaoExtracorporea": "Añadir Circulación Extracorpórea",
    "Canulação venosa": "Canulación venosa",
    "Atrial única": "Atrial única",
    "Bicaval": "Bicaval",
    "Femoral única": "Femoral única",
    "Jugular única": "Yugular única",
    "Jugular + femoral": "Yugular + femoral",
    "Cava superior + femoral": "Cava superior + femoral",
    "Bicaval + cava esquerda": "Bicaval + cava izquierda",
    "Outra": "Otra",
    "Cirurgia em assistência": "Cirugía asistida",
    "Del Nido": "Del Nido",
    "Custodiol": "Custodiol",
    "Anterógrada": "Anterógrada",
    "Retrógrada": "Retrógrada",
    "Combinada": "Combinada",
    "multiperfurada": "Multiperforada",
    "abordagem_valvar": "Abordaje Valvular",
    "Abordagem Valvar": "Abordaje Valvular",
    "Correção de Cardiopatia Congênita": "Corrección de Cardiopatía Congénita",
    "Uso de Videotoracoscopia": "Uso de Videotoracoscopia",
    "Uso de Plataforma Robótica": "Uso de Plataforma Robótica",
    "Uso de Afastador de Partes Moles": "Uso de Separador de Partes Blandas",
    "Especificações do Afastador de Partes Moles": "Especificaciones del Separador de Partes Blandas",
    "Uso de Fixação Rígida": "Uso de Fijación Rígida",
    "Sítio da Fixação Rígida": "Sitio de Fijación Rígida",
    "Especificações da Prótese de Fixação Rígida": "Especificaciones de la Prótesis de Fijación Rígida",
    "Pericardiotomia Posterior Esquerda": "Pericardiotomía Posterior Izquierda",
    "Drenagem Pericárdica": "Drenaje Pericárdico",
    "Drenagem Pleural": "Drenaje Pleural",
    "Tipo de Dreno Pleural Utilizado": "Tipo de Dreno Pleural Utilizado",
    "Plataforma Robótica Utilizada": "Plataforma Robótica Utilizada",
    "Número de Coronárias Acometidas": "Número de Arterias Coronarias Afectadas",
    "Número de Coronárias Abordadas": "Número de Arterias Coronarias Abordadas",
    "Número de Enxertos Utilizados": "Número de Injertos Utilizados",
    "Uso de ATIE": "Uso de ATII  (Arteria Torácica Interna izquierda)",
    "Método de Dissecção da ATIE": "Método de Disección de ATI",
    "Material Utilizado na Dissecção da ATIE": "Material Utilizado en la Disección de ATI",
    "Uso de ATID": "Uso de ATID (Arteria Torácica Inferior derecha)",
    "Método de Dissecção da ATID": "Método de Disección de ATID",
    "Material Utilizado na Dissecção da ATID": "Material Utilizado en la Disección de ATID",
    "Uso de A. Radial": "Uso de Arteria Radial",
    "Uso de A. Gastroepiploica": "Uso de Arteria Gastroepiploica",
    "Uso de A. Epigástrica Inferior": "Uso de Arteria Epigástrica Inferior",
    "Uso de V. Safena Magna": "Uso de Vena Safena Magna",
    "Uso de Estabilizador Cardíaco": "Uso de Estabilizador Cardíaco",
    "Uso de Posicionador Cardíaco": "Uso de Posicionador Cardíaco",
    "Material Utilizado na Anastomose Coronariana": "Material Utilizado en la Anastomosis Coronaria",
    "Marca do Material de Mini Utilizado": "Marca del Material de Mini Utilizado",
    "Angioplastia Programada (Cirurgia Híbrida)": "Angioplastia Programada (Cirugía Híbrida)",
    "Segmentos da Aorta Abordados": "Segmentos de la Aorta Abordados",
    "Uso de Tubo Sintético": "Uso de Tubo Sintético",
    "Especificações do Material Utilizado na Aorta": "Especificaciones del Material Utilizado en la Aorta",
    "Cardiopatia Congênita Abordada": "Cardiopatía Congénita Abordada",
    "Uso de Pericárdio": "Uso de Pericardio",
    "Retirada Endoscópica da Radial": "Extracción Endoscópica de la Arteria Radial",
    "Uso da Técnica Safena No-Touch": "Uso de la Técnica Safena No-Touch",
    "Retirada Endoscópica da Safena": "Extracción Endoscópica de la Safena",
    "Uso de Enxertos Compostos": "Uso de Injertos Compuestos",
    "Estabilizador Utilizado": "Estabilizador Utilizado",
    "Posicionador Utilizado": "Posicionador Utilizado",
    "Plastia Valvar Aórtica": "Plastia Valvular Aórtica",
    "Troca Valvar Aórtica": "Reemplazo Valvular Aórtico",
    "Via de Acesso da Valva Mitral": "Vía de Acceso de la Válvula Mitral",
    "Plastia Valvar Mitral": "Plastia Valvular Mitral",
    "Troca Valvar Mitral": "Reemplazo Valvular Mitral",
    "Fechamento de Auriculeta Esquerda": "Cierre de la Orejuela Izquierda",
    "Plastia Valvar Pulmonar": "Plastia Valvular Pulmonar",
    "Troca Valvar Pulmonar": "Reemplazo Valvular Pulmonar",
    "Plastia Valvar Tricúspide": "Plastia Valvular Tricúspide",
    "Troca Valvar Tricúspide": "Reemplazo Valvular Tricúspide",
    "Reimplante de Coronárias": "Reimplante de Coronarias",
    "Preservação da Valva Aórtica Nativa": "Preservación de la Válvula Aórtica Nativa",
    "Uso de Tubo Valvado": "Uso de Tubo Valvulado",
    "Uso de Técnica em Y": "Uso de Técnica en Y",
    "Uso de Anastomoses Sequenciais": "Uso de Anastomosis Secuenciales",
    "Técnica de Plastia Valvar Aórtica": "Técnica de Plastia Valvular Aórtica",
    "Gradiente Médio Valvar Aórtico Pós-CEC": "Gradiente Medio Valvular Aórtico Post-CEC",
    "Insuficiência Aórtica Pós-CEC": "Insuficiencia Aórtica Post-CEC",
    "Prótese Valvar Aórtica": "Prótesis Valvular Aórtica",
    "Tamanho da Prótese Valvar Aórtica": "Tamaño de la Prótesis Valvular Aórtica",
    "Prótese de Liberação Rápida Aórtica": "Prótesis Aórtica de Liberación Rápida",
    "Especificações da Prótese Aórtica": "Especificaciones de la Prótesis Aórtica",
    "Leak Paravalvar Aórtico": "Fuga Paravalvular Aórtica",
    "Comissurotomia Mitral": "Comisurotomía Mitral",
    "Uso de Neocorda": "Uso de Neocuerda",
    "Uso de Anel Mitral": "Uso de Anillo Mitral",
    "Ressecção de Folheto Mitral": "Resección de Folleto Mitral",
    "Anuloplastia Posterior Mitral": "Anuloplastia Posterior Mitral",
    "Gradiente Médio Valva Mitral Pós-CEC": "Gradiente Medio Valvular Mitral Post-CEC",
    "Insuficiência Mitral Pós-CEC": "Insuficiencia Mitral Post-CEC",
    "Prótese Valvar Mitral": "Prótesis Valvular Mitral",
    "Prótese de Liberação Rápida Mitral": "Prótesis Mitral de Liberación Rápida",
    "Especificações da Prótese Mitral": "Especificaciones de la Prótesis Mitral",
    "Leak Paravalvar Mitral": "Fuga Paravalvular Mitral",
    "Técnica de Plastia Valvar Pulmonar": "Técnica de Plastia Valvular Pulmonar",
    "Gradiente Médio Valvar Pulmonar Pós-CEC": "Gradiente Medio Valvular Pulmonar Post-CEC",
    "Insuficiência Pulmonar Pós-CEC": "Insuficiencia Pulmonar Post-CEC",
    "Prótese Valvar Pulmonar": "Prótesis Valvular Pulmonar",
    "Tamanho da Prótese Valvar Pulmonar": "Tamaño de la Prótesis Valvular Pulmonar",
    "Prótese de Liberação Rápida Pulmonar": "Prótesis Pulmonar de Liberación Rápida",
    "Uso de Prótese Pulmonar Endovascular": "Uso de Prótesis Pulmonar Endovascular",
    "Prótese Pulmonar com Tratamento Anticalcificante": "Prótesis Pulmonar con Tratamiento Anticalcificante",
    "Especificações da Prótese Pulmonar": "Especificaciones de la Prótesis Pulmonar",
    "Leak Paravalvar Pulmonar": "Fuga Paravalvular Pulmonar",
    "Uso de Anel Tricuspide": "Uso de Anillo Tricúspide",
    "Especificações do Anel Tricúspide": "Especificaciones del Anillo Tricúspide",
    "Tipo de Valva do Tubo Valvado": "Tipo de Válvula del Tubo Valvulado",
    "Uso de Prótese Aórtica Endovascular": "Uso de Prótesis Aórtica Endovascular",
    "Prótese Aórtica com Tratamento Anticalcificante": "Prótesis Aórtica con Tratamiento Anticalcificante",
    "Especificações da Neocorda": "Especificaciones de la Neocuerda",
    "Especificações do Anel Mitral": "Especificaciones del Anillo Mitral",
    "Edit_Cirurgia": "Editar Cirugía",
    "Add_Cirurgia": "Añadir Cirugía",
    "Strattner Intuitive": "Strattner Intuitive",
    "Hugo": "Hugo",
    "Visão direta": "Visión directa",
    "Vídeo-assistida": "Vídeo-asistida",
    "Endoscópica": "Endoscópica",
    "Robótica por esternotomia": "Robótica por esternotomía",
    "Robótica por toracotomia lateral": "Robótica por toracotomía lateral",
    "Robótica endoscópica": "Robótica endoscópica",
    "Pinça de coronária convencional": "Pinza de coronaria convencional",
    "Pinça de mini": "Pinza de mini",
    "Tesoura de Potts/Dietrich convencional": "Tijera de Potts/Dietrich convencional",
    "Tesoura de mini": "Tijera de mini",
    "Bisturi elétrico monopolar convencional": "Bisturí eléctrico monopolar convencional",
    "Bisturi elétrico com extensor de lâmina": "Bisturí eléctrico con extensor de lámina",
    "Bisturi harmônico": "Bisturí armónico",
    "Bisturi elétrico bipolar": "Bisturí eléctrico bipolar",
    "Bisturi de vídeo Hook": "Bisturí de vídeo Hook",
    "Bisturi Ligasure": "Bisturí Ligasure",
    "Plataforma robótica": "Plataforma robótica",
    "Medtronic Octopus": "Medtronic Octopus",
    "Medtronic Octopus Nuvo": "Medtronic Octopus Nuvo",
    "Getinge": "Getinge",
    "Medtronic Starfish": "Medtronic Starfish",
    "Getinge Acrobat": "Getinge Acrobat",
    "(mmHg)": "(mmHg)",
    "Comissurotomia": "Comisurotomía",
    "Suspensão de postes comissurais": "Suspensión de postes comisurales",
    "Plicatura valvar": "Plicatura valvular",
    "Ampliação de folheto": "Ampliación de hoja",
    "Anuloplastia": "Anuloplastia",
    "Sem leak": "Sin fuga",
    "Mínimo": "Mínimo",
    "Discreto": "Discreto",
    "Moderado": "Moderado",
    "Importante": "Importante",
    "Não aferido": "No evaluado",
    "Sem insuficiência": "Sin insuficiencia",
    "Mínima": "Mínima",
    "Discreta": "Discreta",
    "Moderada": "Moderada",
    "Prótese biológica": "Prótesis biológica",
    "Prótese mecânica": "Prótesis mecánica",
    "Homoenxerto": "Homoinjerto",
    "Anuloplastia a DeVega": "Anuloplastia de De Vega",
    "Implante de neocorda": "Implante de neocuerda",
    "Desinserção e reinserção tricúspide": "Desinserción y reinserción tricúspide",
    "Papilarotomia": "Papilarotomía",
    "Encurtamento de cordas tendíneas": "Acortamiento de cuerdas tendinosas",
    "Bicuspidização": "Bicuspidización",
    "Massiva": "Masiva",
    "Torrencial": "Torrencial",
    "Não aferida": "No evaluada",
    "Atriotomia esquerda": "Atriotomía izquierda",
    "Transeptal": "Transseptal",
    "Exturbação em sala": "Extubación en sala",
    "Dor pós-operatória": "Dolor postoperatorio",
    "Escala visual analógica da dor (0-10)": "Escala visual analógica del dolor (0-10)",
    "Ferida operatória": "Herida operatoria",
    "Outro sítio": "Otro sitio",
    "Deiscência de ferida operatória": "Dehiscencia de herida operatoria",
    "Esternal": "Esternal",
    "Inguinal": "Inguinal",
    "Periareolar": "Periareolar",
    "Necessidade de nova revascularização não programada": "Necesidad de nueva revascularización no programada",
    "Necessidade de Dispositivo de Assistência Circulatória": "Necesidad de Dispositivo de Asistencia Circulatoria",
    "Tipo de dispositivo de assistência circulatória": "Tipo de dispositivo de asistencia circulatoria",
    "Edit_PosOperatorio": "Editar Postoperatorio",
    "Add_PosOperatorio": "Añadir Postoperatorio",
    "Intra-operatório": "Intraoperatorio",
    "Pós-operatório": "Postoperatorio",
    "Hemácias": "Glóbulos rojos",
    "Plaquetas": "Plaquetas",
    "Plasma Fresco Congelado": "Plasma Fresco Congelado",
    "Crioprecipitado": "Crioprecipitado",
    "Fibrinogênio": "Fibrinógeno",
    "Complexo protrombínico": "Complejo de protrombina",
    "Edit_Hemotransfusao": "Editar Hemotransfusión",
    "Add_Hemotransfusao": "Añadir Hemotransfusión",
    "Edit_Obito": "Editar Óbito",
    "Add_Obito": "Añadir Óbito",
    "Momento do óbito (Intra-operatório, UTI, Enfermaria)": "Momento del óbito (Intraoperatorio, UCI, Enfermería)",
    "ConfirmAction": "¿Estás seguro de que deseas",
    "Activate": "activar",
    "Delete": "eliminar",
    "User": "el usuario",
    "UserManagement": "Gestión de Usuarios",
    "NewUser": "Nuevo Usuario",
    "ID": "ID",
    "Confirmation": "Confirmación",
    "Institutions_Management": "Gestión de Hospitales",
    "Name": "Nombre",
    "ConfirmPassword": "Confirmar Contraseña",
    "Email": "Correo electrónico",
    "Deleted": "¿Eliminado?",
    "Actions": "Acciones",
    "EditUser": "Editar Usuario",
    "Meu_Perfil": "Mi Perfil",
    "Cancel": "Cancelar",
    "UserSavedSuccessfully": "Usuario guardado con éxito",
    "Endereço": "Dirección",
    "Ações": "Acciones",
    "Editar Instituição": "Editar Hospital",
    "Nova Instituição": "Nueva Hospital",
    "Telefone": "Teléfono",
    "CEP": "Código Postal"
  };
  
  export default es;
  